// Mapbox configuration
const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoicmd0aGVsZW4iLCJhIjoiY202dm5raWZ0MDFpbTJub2dxd3lrcDBvcSJ9.nE2XGtpNpTHaz2QUQIo_Bg'

// Default map settings - Tsunami epicenter
const DEFAULT_MAP_SETTINGS = {
  longitude: 116.096248,
  latitude: 16.65541,
  zoom: 4,
  mapStyle: 'mapbox://styles/mapbox/streets-v11',
};

export { MAPBOX_ACCESS_TOKEN, DEFAULT_MAP_SETTINGS }; 